/**
 * Public Routes
 * ============================================================================
 *
 * Purpose:
 * --------
 * Defines routes that do not require authentication.
 * ============================================================================
 */

import { LAYOUT_TYPES, ROUTE_PATHS } from 'navigation/constants';

import type { RouteGroup } from 'navigation/types';
import { lazy } from 'react';

const Website = lazy(() => import('@/features/website/view/Website'));

export const publicRoutes: RouteGroup = {
  name: 'public',
  layout: LAYOUT_TYPES.PUBLIC,
  routes: [
    {
      path: ROUTE_PATHS.HOME,
      component: Website,
      layout: LAYOUT_TYPES.NONE,
      meta: {
        title: 'common:nav.home',
        description: 'Bimanova - Insurance Management Platform',
      },
    },
  ],
};
